import { useCreateCheckin } from '@fanini/shared-api';
import type { CreateCheckIn, CheckIn } from '@fanini/shared-types';

/** Eingabedaten fuer einen Check-in (Alias fuer CreateCheckIn aus shared-types). */
export type CheckInInput = CreateCheckIn;

/**
 * Antwort-Shape eines Check-ins wie sie in sessionStorage gespeichert wird.
 * Entspricht CheckIn aus shared-types ergaenzt um optionale API-Zusatzfelder.
 */
export interface CheckInResult extends CheckIn {
  /** Anzeigename des eingecheckten Fans (optional, von der API). */
  userName?: string;
  /** true wenn der Fan bereits eingecheckt war. */
  alreadyCheckedIn?: boolean;
}

/**
 * Mutation-Hook zum Einchecken eines Fans bei einem Event.
 * Delegiert an useCreateCheckin aus @fanini/shared-api.
 *
 * @returns TanStack Mutation mit mutate/mutateAsync, isPending, isSuccess, isError
 *
 * @example
 * ```tsx
 * const { mutate: checkIn, isPending } = useCheckIn();
 * // QR-Scan: barcode (pdfDriveId) verwenden
 * checkIn({ eventId: 'abc', barcode: 'BARCODE123', method: 'qr' });
 * // Manueller Check-in: userId verwenden
 * checkIn({ eventId: 'abc', userId: 'user_xyz', method: 'manual' });
 * ```
 */
export function useCheckIn() {
  return useCreateCheckin();
}
